export function formatUSPhoneNumber(entry: string | undefined): string {
    if (entry?.length) {
        const regexMatch = entry?.replace(/\D+/g, '').match(/([^\d]*\d[^\d]*){1,}$/);
        const match = regexMatch?.length ? regexMatch[0] : '';

        if (match?.length == 11 && match[0] === '1') {
            const intlCode = '+1 ';
            const part1 = match.length > 2 ? `(${match.substring(1, 4)})` : match;
            const part2 = match.length > 3 ? ` ${match.substring(4, 7)}` : '';
            const part3 = match.length > 6 ? `-${match.substring(7, 11)}` : '';

            return `${intlCode}${part1}${part2}${part3}`;
        }
        const part1 = match?.length > 2 ? `(${match.substring(0, 3)})` : match;
        const part2 = match?.length > 3 ? ` ${match.substring(3, 6)}` : '';
        const part3 = match?.length > 6 ? `-${match.substring(6, 10)}` : '';
        const part4 = match?.length > 10 ? ` ${match.substring(10, match.length)}` : '';

        return `${part1}${part2}${part3}${part4}`;
    }
    return '';
}

export function normaliseUSPhoneNumber(phoneNumberString: string | undefined) {
    if (phoneNumberString) {
        if (phoneNumberString?.length > 1 && phoneNumberString.startsWith('+1')) {
            phoneNumberString = phoneNumberString.substring(2);
        }

        const cleaned = ('' + phoneNumberString).replace(/\D/g, '');

        return cleaned;
    }

    return '';
}

export function formatPhone(phone: string) : string {
    if(!phone) {
        return phone;
    }

    const digits = phone.replace(/^\+1/g, '').replace(/\D+/g, '');
    return `${digits.slice(0,3)}.${digits.slice(3,6)}.${digits.slice(6,10)}`;
}